module.exports = __webpack_public_path__ + "img/Mercari.f8d9d467.png";